import firebase from 'firebase/compat/app'; // この一行は必須
// 以下の行は、必要なFirebaseのサービスをimport
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
// firebaseの設定ファイルの読み込み
import {firebaseConfig} from './config';

// firebaseの初期化
firebase.initializeApp(firebaseConfig);
// firebaseのサービスのインスタンスを作成
export const auth = firebase.auth();
export const db = firebase.firestore();
export const functions = firebase.functions();

// timestampのインスタンスを初期化
export const FirebaseTimestamp = firebase.firestore.Timestamp;